import InstantPaymentsSignUp from "./InstantPaymentsSignUp";

export default InstantPaymentsSignUp;